"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mainToCsv = exports.mainTotext = exports.mainToMjml = void 0;

var _base = require("./common/base");

var _helpers = require("./common/helpers");

var _formatDefinition = require("./common/formatDefinition");

var mainToMjml = function mainToMjml(item, blockRenderer) {
  var items = '';
  (item.children || []).forEach(function (x) {
    items += blockRenderer(x, blockRenderer, true);
  });

  if (item.properties.isPartialTemplate) {
    return items;
  }

  item.properties.children = items;

  if (item.properties.emailWidth && item.properties.emailWidth.indexOf('%') === -1) {
    var wrapper = (0, _base.toMjml)('mj-wrapper', {
      'emailBackgroundColor': item.properties.emailBackgroundColor,
      'fullWidth': 'full-width',
      'padding': item.properties.padding || '0px',
      'children': items,
      'backgroundUrl': item.properties.backgroundUrl || '',
      'backgroundSize': item.properties.backgroundSize || 'contain',
      'backgroundRepeat': item.properties.backgroundRepeat || 'no-repeat',
      'border': (0, _helpers.computeBorder)(item.properties) && (0, _helpers.computeBorder)(item.properties).value,
      'backgroundPositionX': item.properties.backgroundPositionX,
      'backgroundPositionY': item.properties.backgroundPositionY
    }, _formatDefinition.EDIE_PROPS[_formatDefinition.EDIE_BLOCK_TYPE.MAIN]); // these are used for the wrapper, do not add at the body.

    delete item.properties.padding;
    delete item.properties.backgroundUrl;
    delete item.properties.backgroundSize;
    delete item.properties.backgroundRepeat;
    delete item.properties.borderSize;
    delete item.properties.borderColor;
    delete item.properties.backgroundPositionX;
    delete item.properties.backgroundPositionY;
    item.properties.children = wrapper;
  }

  return (0, _base.toMjml)('mj-body', item.properties, _formatDefinition.EDIE_PROPS[_formatDefinition.EDIE_BLOCK_TYPE.MAIN]);
};

exports.mainToMjml = mainToMjml;

var mainTotext = function mainTotext(item, blockRenderer) {
  var items = '';
  (item.children || []).forEach(function (x) {
    items += blockRenderer(x, blockRenderer, true);
  });
  return items + '\r\n';
};

exports.mainTotext = mainTotext;

var mainToCsv = function mainToCsv(item, blockRenderer, isTopLevelNode, templateMetadata) {
  var items = '';
  (item.children || []).forEach(function (x) {
    items += blockRenderer(x, blockRenderer, true, templateMetadata);
  });
  return items;
};

exports.mainToCsv = mainToCsv;